import React from 'react';
import moment from 'moment';
import { useField } from 'formik';
import { DatePickerProps, Space } from 'antd';
import DatePicker from 'components/new-ui/base/date-picker/DatePicker';
import { DatePickerErrorDiv } from 'components/new-ui/base/date-picker/styles';
import { PickerPanelDateProps } from 'antd/lib/calendar/generateCalendar';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';
import DDatePicker, { DatePickerFormats, DatePickerInputValue } from 'components/ui/base/datepicker/Datepicker';
import { RefWrapper } from '../formSelect/styles';

type Props = Pick<PickerPanelDateProps<moment.Moment>, 'showTime' | 'disabledTime'> &
    Pick<DatePickerProps, 'placeholder' | 'format' | 'disabled' | 'disabledDate'> & {
        fieldName: string;
        label?: string;
        required?: boolean;
        refNumber?: string;
        style?: {
            root?: React.CSSProperties;
            pickerWrapper?: React.CSSProperties;
            picker?: React.CSSProperties;
        };
        disabled?: boolean;
        showTime?: boolean;
        formats?: DatePickerFormats;
        getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
        serializeDate?: (value: DatePickerInputValue) => string;
    };

const FormDatePicker: React.FC<Props> = ({
    fieldName,
    label,
    required,
    refNumber,
    style,
    disabled,
    serializeDate,
    showTime,
}) => {
    const [field, meta, helpers] = useField(fieldName);

    return (
        <div
            style={
                style?.root ?? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }
            }
        >
            <Space size={8}>
                {refNumber && <RefWrapper>{refNumber}</RefWrapper>}
                {required && <LabelRequiredSymbol />}
                {label}
            </Space>
            <div
                style={
                    style?.pickerWrapper ?? {
                        maxWidth: 489,
                        flexGrow: 1,
                    }
                }
            >
                <DDatePicker
                    // overrides the styles for the default date picker
                    DatePickerComponent={DatePicker}
                    id={field.name}
                    showTime={showTime}
                    status={meta.touched && meta.error ? 'error' : undefined}
                    fieldProps={field}
                    fieldHelpers={helpers}
                    disabled={disabled}
                    serializeDate={serializeDate}
                    style={
                        style?.picker ?? {
                            width: '100%',
                        }
                    }
                />
                {meta.touched && meta.error && <DatePickerErrorDiv>{meta.error}</DatePickerErrorDiv>}
            </div>
        </div>
    );
};

export default FormDatePicker;
